import { useTranslate } from 'react-admin';

export function useAdminText() {
  const translate = useTranslate();
  return (key: string, fallback: string, values: Record<string, unknown> = {}) =>
    translate(`admin.${key}`, { _: fallback, ...values });
}
